'use client'

import ProductCard from '@/components/template-one/cursos/product-card'
import CourseCardSkeleton from '@/components/template-one/skeleton/course-card-skeleton'
import type { CourseType } from '@/types/course-type'

const SKELETON_CARDS = 8

interface ProductCardGroupProps {
  products: CourseType[]
  columns: number
  isLoading?: boolean
}

export default function ProductCardGroup({
  products,
  columns,
  isLoading = false,
}: ProductCardGroupProps) {
  const gridClassName = `mt-6 mb-9 grid w-full lg:grid-cols-${columns} grid-cols-1 justify-start gap-x-5 gap-y-8 md:grid-cols-2`

  if (isLoading) {
    return (
      <div aria-busy="true" className={gridClassName}>
        {Array.from({ length: SKELETON_CARDS }, (_, index) => (
          <CourseCardSkeleton key={`skeleton-${index}`} />
        ))}
      </div>
    )
  }

  if (products.length === 0) {
    return null
  }

  return (
    <div className={gridClassName}>
      {products.map(product => (
        <ProductCard
          hasSharedImageTransition
          key={product.reference}
          product={product}
        />
      ))}
    </div>
  )
}
